import { Controller } from "@hotwired/stimulus"
import WebViewer from "@pdftron/pdfjs-express"

const DISABLED_ELEMENTS = [
  "printModal",
  "freeHandToolGroupButton",
  "selectToolButton",
  "textToolGroupButton",
  "shapeToolGroupButton",
  "signatureToolButton",
  "freeTextToolButton",
  "stickyToolButton",
  "miscToolGroupButton",
  "toolsButton",
  "searchButton",
  "menuButton",
  "leftPanelButton",
  "eraserToolButton",
  "viewControlsButton",
  "panToolButton",
  "contextMenuPopup",
]

// PDF.js Express viewer for job file show page.
export default class extends Controller {
  static values = {
    handle: String,
    fp: Boolean,
    as: String,
  }

  connect() {
    this.abortController = new AbortController()
    this.initialize()
  }

  disconnect() {
    this.abortController.abort()
    this.viewerInstance?.UI?.dispose?.()
    this.viewerInstance = null
  }

  initialize() {
    const initialDoc = this.fpValue
      ? `https://cdn.filepicker.io/${this.handleValue}`
      : `${window.location.origin}${this.asValue}`

    WebViewer(
      {
        path: "/pdftron/pdfjsexpress",
        css: "/pdftron/pdfjsexpress/ui/style.css",
        initialDoc,
        disabledElements: DISABLED_ELEMENTS,
      },
      this.element
    ).then((instance) => {
      if (this.abortController.signal.aborted) {
        instance.UI?.dispose?.()
        return
      }

      this.viewerInstance = instance
      instance.setHeaderItems((header) => {
        const items = header.getItems().slice(2, -9)
        header.update(items)
      })
    })
  }
}
